import * as R from 'ramda';
import { Project } from '../../../../project/Project';
import { CaseId, CaseSpecification } from '../../../cases/CaseSpecification';
import { getProjectCasesSpecifications } from './getProjectCasesSpecifications';

export const getCasesSpecificationsById = (project: Project): Record<CaseId, CaseSpecification> =>
  R.pipe(getProjectCasesSpecifications, R.indexBy(R.prop('id')))(project);
